module.exports = __webpack_public_path__ + "img/logo.1a952785.png";